import { Dialog } from "@mui/material";
import React from "react";

export default function ConfimationPopup({
  handleClose,
  component,
  open,
  maxWidth = "xs",
}) {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth={maxWidth}
      fullWidth
      PaperProps={{
        sx: {
          backgroundColor: "#FFFFFF",
          borderRadius: "16px",
          padding: "24px",
          boxShadow: "0px 10px 40px rgba(0,0,0,0.15)",
          overflow: "visible", // allows gif to overflow slightly
        },
      }}
      BackdropProps={{
        sx: {
          backgroundColor: "rgba(0,0,0,0.5)",
        },
      }}
    >
      {component}
    </Dialog>
  );
}
